module.exports = __webpack_public_path__ + "img/washer-active-icon.60670f5a.svg";